import { render, staticRenderFns } from "./EventBoothQuestionPage.vue?vue&type=template&id=218681b4"
import script from "./EventBoothQuestionPage.vue?vue&type=script&lang=js"
export * from "./EventBoothQuestionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports